module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dorothy Garlock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Dorothy Garlock")]), _vm._v(" is the author of more than 50 novels that have sold 15 million+ combined copies and are published in 15 languages. She lives in Iowa.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12I9sXK/tc-custom/9780446550918.jpg?1736305996493",
      "alt": "This image is the cover for the book Moon Looked Down"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Moon Looked Down\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“The premier writer of Americana romance” crafts a story of one woman’s fight to save her heartland dreams during the early days of World War II ("), _c('i', [_vm._v("Booklist")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Young Sophie Heller and her family sacrificed everything to escape Nazi Germany and find safety in America. But as war fever sweeps their small town of Victory, Illinois, they become targets of suspicion, whispered accusations of treason, and a vicious attack. Sophie’s father won’t go to the law for help, but Sophie, now a newspaperwoman, vows to expose those behind the threats no matter what it takes. Her only ally is Cole Ambrose, a teacher whose quiet strength slowly earns her trust . . . and hides secret pain. As hidden enemies move in to destroy the Hellers once and for all, will Sophie and Cole’s defiance—and unexpected love—be enough?"), _c('br'), _c('br'), _c('b', [_vm._v("Praise for Dorothy Garlock")]), _c('br'), _c('br'), _vm._v("“A gifted writer.” —"), _c('i', [_vm._v("Chicago Sun-Times")]), _c('br'), _c('br'), _vm._v("“There is nothing better than Dorothy Garlock at her best.” —Sandra Brown, #1 "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author"), _c('br'), _c('br'), _vm._v("“No one brings home small-town America in a more picturesque manner than bestselling author Dorothy Garlock.” —"), _c('i', [_vm._v("Under the Covers Book Reviews")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grand Central Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0